function normalizeBaseUrl(value: string | undefined): string {
	return (value ?? "").replace(/\/+$/, "");
}

const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]"]);

/** True only for `npm run dev` on localhost — not staging/production builds. */
export function isReadOnlyPreviewAllowed(): boolean {
	if (!import.meta.env.DEV) return false;
	if (typeof window === "undefined") return false;
	return LOCAL_DEV_HOSTS.has(window.location.hostname);
}

export function getApiBaseUrl(): string {
	return normalizeBaseUrl(import.meta.env.VITE_API_BASE_URL);
}

export function getMediaBaseUrl(): string {
	return normalizeBaseUrl(import.meta.env.VITE_MEDIA_BASE_URL);
}

export function getSevenRoomsMediaBaseUrl(): string {
	return normalizeBaseUrl(import.meta.env.VITE_SEVENROOMS_MEDIA_BASE_URL);
}
